export default (state, { oidcUserManager }) => {
	state.oidcUserManager = oidcUserManager;
}